import React, { useState } from 'react'
import { connect } from 'react-redux'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'

import IncludedUsersTable from './IncludedUsersTable'
import ExcludedUsersTable from './ExcludedUsersTable'
import classnames from 'classnames'

const ReportDetails = ({ reportDetails, selectedCompany }) => {
  const [activeTab, setActiveTab] = useState('1')

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }
  if (reportDetails) {
    return (
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: activeTab === '1' })}
              onClick={() => {
                toggle('1')
              }}>
                Backup Users
              </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({active: activeTab === '2' })}
              onClick={() => {
                toggle('2')
              }}>
                Excluded Users
              </NavLink>
          </NavItem>
        </Nav>
        <div>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1" style={{ paddingTop: '25px' }}>
              <IncludedUsersTable reportDetails={reportDetails} />
            </TabPane>
            <TabPane tabId="2" style={{ paddingTop: '25px' }}>
              {activeTab === '2' && <ExcludedUsersTable reportDetails={reportDetails} selectedCompany={selectedCompany} />}
            </TabPane>
          </TabContent>
        </div>
      </div>

    )
  } else {
    return <div>Client not found</div>
  }
}

const mapStateToProps = (state) => ({
  selectedCompany: state.reports.selectedCompany,
})

export default connect(mapStateToProps, null)(ReportDetails)
